import { render, staticRenderFns } from "./Athletes.vue?vue&type=template&id=1fc530a4&"
import script from "./Athletes.vue?vue&type=script&lang=js&"
export * from "./Athletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports